(() => {
  // 1. UPDATED SELECTORS to match your latest design
  const WIDGET_SEL = ".pdp-widget";
  const OPTION_SEL = ".pdp-widget__option";
  const ATC_BTN_SEL = ".product-form__submit"; 

  const $ = (sel, root = document) => root.querySelector(sel);
  
  function normText(s) {
    return (s || "").replace(/\s+/g, " ").trim();
  }

  // 2. Optimized Price Extraction
  function extractMainPriceFromOption(option) {
    if (!option) return "";
    
    // Specifically target the price span in your latest design
    const priceSpan = option.querySelector('.pdp-widget__price');
    if (priceSpan) return normText(priceSpan.textContent);

    // Fallback regex if span is missing
    const text = normText(option.innerText);
    const matches = Array.from(text.matchAll(/([A-Z]{0,3}\$ ?\d[\d,]*(?:\.\d{2})?)/g));
    if (!matches.length) return "";
    
    const candidates = matches
      .map((m) => ({ value: normText(m[1]), index: m.index }))
      .filter((m) => {
        const before = text.slice(Math.max(0, m.index - 12), m.index).toLowerCase();
        return !before.includes("save");
      });
    return candidates.length ? candidates[0].value : normText(matches[0][1]);
  }

  function updateAtcButton(widgetContainer) {
    const root = widgetContainer.closest('.product__info-container') || 
                 widgetContainer.closest('.product__info-wrapper') || 
                 widgetContainer.closest('#qv-modal') || 
                 document;

    const btn = $(ATC_BTN_SEL, root);
    if (!btn) return;

    // Search for active option using the updated class
    const activeOption = widgetContainer.querySelector(".pdp-widget__option.active");
    if (!activeOption) return;

    const isOneTime = activeOption.getAttribute('data-plan-id') === "";
    const price = extractMainPriceFromOption(activeOption);

    const textEl = btn.querySelector(".qv-atc-text");
    const priceEl = btn.querySelector("[data-qv-atc-price]");
    const intervalEl = btn.querySelector("[data-qv-atc-interval]");

    if (isOneTime) {
      if (textEl) textEl.textContent = "Add to cart";
      if (priceEl) priceEl.textContent = ` — ${price}`;
      if (intervalEl) intervalEl.textContent = "";
    } else {
      if (textEl) textEl.textContent = "Subscribe";
      if (priceEl) priceEl.textContent = ` — ${price}`;
      
      // Update the interval on the button if needed (e.g., " / 90 days")
      const intervalText = activeOption.querySelector('.pdp-widget__interval');
      if (intervalEl && intervalText) {
         const intervalVal = intervalText.textContent.toLowerCase().split('every')[1] || "";
         intervalEl.textContent = intervalVal ? ` / every ${intervalVal.trim()}` : "";
      }
    }
  }

  function bindWidget(container) {
    if (container.dataset.qvBound === "1") return;
    container.dataset.qvBound = "1";

    // Listen for clicks on the new option class
    container.addEventListener("click", (e) => {
      const option = e.target.closest(OPTION_SEL);
      if (option) {
        // Small delay to let the widget's own click logic toggle the '.active' class
        setTimeout(() => updateAtcButton(container), 20);
      }
    });

    // Initial sync
    updateAtcButton(container);
  }

  const scanForWidgets = () => {
    document.querySelectorAll(WIDGET_SEL).forEach(container => {
      bindWidget(container);
    });
  };

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", scanForWidgets);
  } else {
    scanForWidgets();
  }

  // Monitor for dynamic content (Quick View modal popups)
  const globalObserver = new MutationObserver((mutations) => {
    for (const mutation of mutations) {
      if (mutation.addedNodes.length) scanForWidgets();
    }
  });
  globalObserver.observe(document.body, { childList: true, subtree: true });

})();